import styled from 'styled-components'
import Loader from 'react-loader-spinner'

export const StyledLoader = styled(Loader)`
  position: absolute;
  top: 40vh;
  margin: 0 auto;
  left: 0;
  right: 0;
  width: fit-content;
`
